import { useEffect, useState } from "react";
import { openBookStream } from "@/lib/liveTransport";

const IDLE = { status: "idle", bids: [], asks: [], mid: null, spread: null, maxCum: 0 };

// Live order book for SYM-USD via the backend relay → { status, bids:[{p,s,cum}], asks:[...], mid, spread }
export function useOrderBook(symbol, enabled = true, depth = 12) {
  const sym = (symbol || "").toUpperCase();
  const [book, setBook] = useState(IDLE);

  useEffect(() => {
    if (!enabled || !sym) { setBook(IDLE); return undefined; }
    setBook({ ...IDLE, status: "connecting" });
    const close = openBookStream(sym, depth, ({ bids, asks }) => {
      let cum = 0;
      const b = bids.map(([p, s]) => ({ p, s, cum: (cum += s) }));
      cum = 0;
      const a = asks.map(([p, s]) => ({ p, s, cum: (cum += s) }));
      const bestBid = b[0]?.p, bestAsk = a[0]?.p;
      setBook({
        status: "live", bids: b, asks: a,
        mid: bestBid && bestAsk ? (bestBid + bestAsk) / 2 : null,
        spread: bestBid && bestAsk ? bestAsk - bestBid : null,
        maxCum: Math.max(b[b.length - 1]?.cum || 0, a[a.length - 1]?.cum || 0),
      });
    }, (s) => { if (s !== "live") setBook((bk) => (bk.status === "live" && s === "connecting" ? bk : { ...bk, status: s })); });
    return close;
  }, [sym, enabled, depth]);

  return book;
}
